import React from 'react';
import { EditableRendererProvider } from '@bay-email/editor';
import { ActiveEditableProvider } from './ActiveEditableProvider';
import { TiptapEditable } from './index';

// Both providers must sit above every canvas + AttributePanel pair. StandardLayout
// gets them through ExtensionProvider; SimpleLayout has no ExtensionProvider and
// mounts this at its root. Without them RichTextField never shows a toolbar.
export function EditableProviders({ children }: { children?: React.ReactNode }) {
	return (
		<ActiveEditableProvider>
			<EditableRendererProvider Editable={TiptapEditable}>{children}</EditableRendererProvider>
		</ActiveEditableProvider>
	);
}
